import { useCallback, useRef } from 'react';
import { dbService } from '../services/firebase-db.service';
import { useSmoothGps } from './useSmoothGps';

/** Keep publishing rider GPS during navigation + confirmation screens */
export function useRiderLocationSync(jobId?: string, riderId?: string, enabled = true) {
  const lastSyncRef = useRef(0);
  const hasSyncedInitialRef = useRef(false);

  const sync = useCallback(
    (location: { lat: number; lng: number }) => {
      if (!jobId || !enabled) return;
      const now = Date.now();
      const isFirstFix = !hasSyncedInitialRef.current;
      if (!isFirstFix && now - lastSyncRef.current < 4000) return;
      lastSyncRef.current = now;
      hasSyncedInitialRef.current = true;
      void dbService.updateRiderLocation(jobId, location, riderId).catch((err) => {
        console.error('[GPS] sync failed:', err);
      });
    },
    [jobId, riderId, enabled]
  );

  return useSmoothGps(Boolean(jobId) && enabled, sync);
}
